export default __webpack_public_path__ + "static/media/UBF.85f9624b.svg";